module.exports = __webpack_public_path__ + "static/media/Stroke-7.06ed7082.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/stroke7/fonts/Stroke-7.svg?f72xkr
// module id = 781
// module chunks = 0